function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M59.4,11.87,48,.48A1.57,1.57,0,0,0,47,.08H4a4,4,0,0,0-4,4V55.94a4,4,0,0,0,4,4H56a4,4,0,0,0,4-4v-43A2.46,2.46,0,0,0,59.4,11.87ZM41.1,3.09V16.42a.08.08,0,0,1-.08.09H36.87V3.09Zm-7.32,0V16.51H18.9a.09.09,0,0,1-.09-.09V3.09ZM13.93,56.93V38.3A6.35,6.35,0,0,1,20.28,32H40.69A6.35,6.35,0,0,1,47,38.3V56.92H13.93Zm43-1a1,1,0,0,1-1,1H50V38.3A9.41,9.41,0,0,0,40.69,29H20.36A9.41,9.41,0,0,0,11,38.3V56.92H4a1,1,0,0,1-1-1V4.06a1,1,0,0,1,1-1H15.8V16.42a3.08,3.08,0,0,0,3.09,3.08H41a3.08,3.08,0,0,0,3.09-3.08V3.09h2.27L56.86,13.58l0,42.37ZM41.43,48.06A1.46,1.46,0,0,1,40,49.52H21.34a1.46,1.46,0,0,1,0-2.92H39.88A1.48,1.48,0,0,1,41.43,48.06Zm0-7.8A1.46,1.46,0,0,1,40,41.72H21.34a1.47,1.47,0,0,1,0-2.93H39.88A1.39,1.39,0,0,1,41.43,40.26Z",
  transform: "translate(-0.03 -0.08)"
});

var SvgSave = function SvgSave(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Save1",
    viewBox: "0 0 60 60",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSave, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Save.d1fe86c6.svg";
export { ForwardRef as ReactComponent };